// extracted by mini-css-extract-plugin
export default {"fr-view":"CourseCard_fr-view__zZ5Ce","container":"CourseCard_container__30oIO","icon":"CourseCard_icon__PEn7Y","title":"CourseCard_title__lat+J"};